import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Button, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { faLink, faPlus, faUpload, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import AddDocumentModal from './components/addDocumentModal';
import AddUrlModal from './components/addURLModal';
import AddFileModal from './components/addFileModal';
import ActivityTypes from '../../../../../../enums/activityTypes';
import { useCreateResourceSetMutation } from '../../../../../../features/authentication/qSetApiSlice';
import { useNavigate } from 'react-router';
import '../../styles.scss';
import CustomToast from '../../../../../../components/Toast';

const CreateResourceSetModal = ({ showModal, setShowModal }) => {
  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false);
  const [showAddUrlModal, setShowAddUrlModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [createResourceSet, { isLoading: resourceIsLoading }] = useCreateResourceSetMutation();
  const [newSetName, setNewSetName] = useState('');
  const navigate = useNavigate();

  const handleCreateNewResourceSet = async (event) => {
    event.preventDefault();
    const option = {
      description: newSetName,
      activityType: ActivityTypes.Documents
    };

    try {
      const result = await createResourceSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        navigate(`${result.data}`);
      }
    } catch (error) {
      CustomToast('Failed To Create Resource.', 'error');
      console.log(error);
    }
  };

  const handleNewSetNameValidation = (event) => {
    var inputValue = event.target.value;

    if (inputValue.length > 100) {
      event.target.setCustomValidity('Name must be 100 characters or less!');
    } else {
      event.target.setCustomValidity('');
    }
  };

  const GetActionButton = (icon, label, onClick, resourceIsLoading) => {
    return (
      <Col className={`${resourceIsLoading ? 'disabled' : ''} col-4`}>
        <button
          className="w-100 p-2 btn-questionset text-start cursor-pointer"
          onClick={onClick}
          disabled={resourceIsLoading}
        >
          <div className="align-items-center d-flex">
            <div className="align-items-center blue-icon d-flex fs-5 justify-content-center">
              <FontAwesomeIcon icon={icon} />
            </div>
            <p className="m-0">{label}</p>
          </div>
        </button>
      </Col>
    );
  };
  
  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        titleName='Create Resource Set'
        contentWidth='655px'>
        <Form className='d-flex flex-row' onSubmit={(e) => handleCreateNewResourceSet(e)}>
          <div className='d-flex flex-column w-100'>
            <Form.Group id="setName" className='w-100'>
              <Form.Label>Set Name</Form.Label>
              <OverlayTrigger
                key={'question-tooltip'}
                placement="right"
                overlay={
                  <Tooltip className="modal-title-tooltip">
                    <div>
                      <strong>Add Document: </strong>
                    Use our online editor to create a custom document<br></br><br></br>
                      <strong>Add URL: </strong>
                    Add a URL that the students can click on to go to a web page<br></br><br></br>
                      <strong>Upload File: </strong>
                    Upload a Word, PowerPoint, PDF, MP3 or MP4 file
                    </div>
                  </Tooltip>
                }>
                <FontAwesomeIcon id='infoIcon' className="circle-question mx-1" icon={faCircleQuestion} />
              </OverlayTrigger>
              <div className='d-flex flex-row gap-3 align-items-center'>
                <Form.Control disabled={resourceIsLoading} type="text" className='w-100' onChange={(e) => setNewSetName(e.target.value)} required onInput={handleNewSetNameValidation} />
                <Button disabled={resourceIsLoading || newSetName.length <= 0} variant='castleRed' className='btn-width' type='submit'>{resourceIsLoading ? 'Saving...' : 'Save'}</Button>
              </div>
            </Form.Group>
          </div>
        </Form>

        <div className='my-3 d-flex align-items-center divider-line'>
          <div/>
          <span className='mx-2 fs-14'>OR</span>
          <div/>
        </div>

        <div>
          <h2 className='fw-500'>Select Resources</h2>
          <p>Select the resource first, then create a new resource set.</p>
          <Row className='row g-3'>
            {GetActionButton(faPlus, 'Add Document', () => setShowAddDocumentModal(true), resourceIsLoading)}
            {GetActionButton(faLink, 'Add URL', () => setShowAddUrlModal(true), resourceIsLoading)}
            {GetActionButton(faUpload, 'Upload File', () => setShowUploadFileModal(true), resourceIsLoading)}
          </Row>
        </div>
      </Modal>

      <AddDocumentModal showModal={showAddDocumentModal} setShowModal={setShowAddDocumentModal} />
      <AddUrlModal showModal={showAddUrlModal} setShowModal={setShowAddUrlModal} />
      <AddFileModal showModal={showUploadFileModal} setShowModal={setShowUploadFileModal} />
    </>
  );
};

CreateResourceSetModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func
};

export default CreateResourceSetModal;